import giftImage from "../../../img/gift.png";
import { useForm } from "react-hook-form";
import ButtonSubmissionSpinner from "../../Common/ButtonSubmissionSpinner";
import { useEffect, useState } from "react";
import SuccessCouponCode from "./SuccessCouponCode";
import { usePlansProvider } from "../../../Contexts/plansContext";
import { useUpdateSubscriptionPlans } from "../../../api/subscriptionPlan.api";
import { useNavigation } from "../../../Contexts/navigationContext";
import { useSearchParams } from "react-router-dom";


const ReferralSection = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    clearErrors,
  } = useForm({
    defaultValues: {
      couponCode: "",
    },
  });
  const [searchParams] = useSearchParams();
  const { setPlans, setCouponCode, couponCode, amountSaved, setAmountSaved, refetchPlans } = usePlansProvider();
  const { referralRef, scrollToPlans } = useNavigation();
  const [showSuccessPopUp,setShowSuccessPopUp] = useState(false);

  const updatePlans = useUpdateSubscriptionPlans();
  const isApplyingCouponCode = updatePlans.isPending;

  const onSubmit = (data) => {
    // Use DOM value as fallback for typing animation from banner
    const couponValue = data.couponCode || document.getElementById("ppa-course-coupon-code-input")?.value;

    if(couponValue) {
      updatePlans.mutate(couponValue, {
        onSuccess: (res) => {
          setCouponCode(couponValue);
          setShowSuccessPopUp(true);
          setPlans(res.Response);
        },
        onError: () => {
          setError("couponCode", {
            type: "manual",
            message: "Invalid coupon code. Please try again.",
          });
        },
      });
    }
  };

  const removeCouponCode = () => {
    reset({ couponCode: "" });
    clearErrors("couponCode");
    setCouponCode(null);
    setShowSuccessPopUp(false);
    refetchPlans();
    const params = new URLSearchParams(window.location.search);
    params.delete("applyCode");
    params.delete("coupon_code");
    params.delete("scrollTo");
    const newUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : "");
    window.history.replaceState({}, "", newUrl);
  };

  useEffect(() => {
  const coupon = searchParams.get("coupon_code") || searchParams.get("applyCode");

  if (coupon) {
    updatePlans.mutate(coupon, {
      onSuccess: (res) => {
        setCouponCode(coupon);
        setPlans(res.Response);

        const twelveMonthPlan = res.Response.find(
          (plan) => plan.subscription_name?.trim() === "12 Months"
        );

        if (twelveMonthPlan) {
          const mrp = Number(twelveMonthPlan?.mrp);
          const discount = Number(twelveMonthPlan?.discount);
          if (mrp && discount) {
            const discountAmount = Math.floor((mrp * discount) / 100);
            setAmountSaved(String(discountAmount));
          }
        }

        // Show success popup only after coupon is successfully applied
        setShowSuccessPopUp(true);
      },
      onError: () => {
        setError("couponCode", {
          type: "manual",
          message: "Invalid coupon code. Please try again.",
        });
      },
    });

    reset({ couponCode: coupon });

    setTimeout(() => {
      referralRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  }
}, [searchParams.get("t")]);

  return (
    <div className="bg-[rgba(24,27,67,1)] pb-[60px]" ref={referralRef}>
      <div className="max-w-[771px] w-full mx-auto flex flex-col items-center sm:gap-6 gap-4">
        <form onSubmit={handleSubmit(onSubmit)} className="sm:w-[499px] sm:h-[48px] px-5 sm:px-0">
          <div className="flex items-stretch overflow-hidden border rounded-[8px] bg-white min-w-[335px]">
            <input
              type="text"
              placeholder="Enter Code"
              id="ppa-course-coupon-code-input"
              {...register("couponCode", {
                validate: (value) => {
                  // Also check DOM input value for typing animation from banner
                  const domInputValue = document.getElementById("ppa-course-coupon-code-input")?.value;
                  if (!couponCode && !value.trim() && !domInputValue?.trim()) {
                    return "Please enter a coupon code.";
                  }
                  return true;
                },
              })}
              className="flex-1 sm:py-1 sm:pr-1 py-2 pr-2 pl-3  text-[16px] bg-white text-black outline-none"
            />
            {!couponCode ? (
              <button
                type="submit"
                id="ppa-course-apply-coupon-code-button"
                className="bg-[rgba(68,75,171,1)] text-white px-6 py-2 text-[16px] leading-6 rounded-[4px] sm:m-1 m-2  flex items-center gap-2"
              >
                Apply
                {isApplyingCouponCode && <ButtonSubmissionSpinner />}
              </button>
            ) : (
              <button
                type="button"
                onClick={removeCouponCode}
                className="bg-[rgba(68,75,171,1)] text-white px-6 py-2 text-[16px] leading-6 rounded-[4px] m-2 flex items-center gap-2"
              >
                Remove
              </button>
            )}

          </div>
          {errors.couponCode && (
            <p className="text-red-400 text-[16px] mt-3 text-center">
              {errors.couponCode.message}
            </p>
          )}
        </form>
        <div className="flex items-center justify-center">
          <div className="flex gap-3 items-center justify-center md:justify-start mt-5">
            <img src={giftImage} height={24} width={24} alt="Gift icon" />
            <p className="text-[16px] md:text-[20px] leading-6 text-white font-gilroy-medium">
              I have a Referral Code/Coupon Code!
            </p>
          </div>
        </div>
        <p className="text-yellow-300 text-sm md:text-[20px] font-gilroy-medium text-center md:text-left">
          To be paid as a one-time payment. Easy EMI options available with HDFC Cards.
        </p>
      </div>
      {showSuccessPopUp && couponCode  && 
        <SuccessCouponCode 
          onClose={() => {
            setShowSuccessPopUp(false);
            scrollToPlans();
          }} 
          couponCode={couponCode} 
          amountSaved={amountSaved}
        /> 
      }
    </div>
  );
};

export default ReferralSection;